import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=1bdd473e&scoped=true&"
import script from "./filters.vue?vue&type=script&lang=js&"
export * from "./filters.vue?vue&type=script&lang=js&"
import style0 from "./filters.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./filters.vue?vue&type=style&index=1&id=1bdd473e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd473e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bdd473e')) {
      api.createRecord('1bdd473e', component.options)
    } else {
      api.reload('1bdd473e', component.options)
    }
    module.hot.accept("./filters.vue?vue&type=template&id=1bdd473e&scoped=true&", function () {
      api.rerender('1bdd473e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/components/filters.vue"
export default component.exports